import { render, staticRenderFns } from "./step_done_former.vue?vue&type=template&id=0dd0fbb4&"
import script from "./step_done_former.vue?vue&type=script&lang=js&"
export * from "./step_done_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports